import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { widgetDataSelector } from 'app/store/selectors/dashboards';
import { widgetLoadingIdSelector } from 'app/store/selectors/widgets';
import WidgetContainer from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/WidgetContainer/WidgetContainer';
import StatusWidgetCard from './StatusWidgetCard';
const StatusWidget = ({ allEpisodes, displayedEpisodes, widget, stepProjects, progressionStatus, activeEpisodesByWidget, setActiveEpisodesByWidget, steps, assetType, }) => {
    const { projectId } = useParams();
    const [mode, setMode] = useState('elements');
    const widgetData = useSelector(widgetDataSelector(widget.id));
    const widgetLoadingId = useSelector(widgetLoadingIdSelector);
    const isLoading = widgetLoadingId === widget.id;
    const sortedEpisodes = displayedEpisodes
        .map((episodeId) => {
        const episodeInst = allEpisodes.find((e) => e.id === episodeId);
        return episodeInst;
    })
        // @ts-expect-error
        .sort((a, b) => (a === null || a === void 0 ? void 0 : a.name) - (b === null || b === void 0 ? void 0 : b.name));
    const noSteps = steps.length === 0;
    const noEpisodes = displayedEpisodes.length === 0;
    return (_jsxs(WidgetContainer, { widget: widget, mode: mode, setMode: setMode, allEpisodes: allEpisodes, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, isLoading: isLoading, displayError: noSteps || noEpisodes, displayActionButton: true, assetType: assetType, children: [noSteps || noEpisodes ? (_jsx("p", { style: { fontSize: '20px' }, children: `No ${noSteps && noEpisodes ? 'steps and episodes' : noSteps ? 'steps' : 'episodes'} were set` })) : null, !noSteps &&
                sortedEpisodes.map((episodeInst) => {
                    if (!episodeInst)
                        return;
                    const { id: episodeId } = episodeInst;
                    const episodeData = widgetData === null || widgetData === void 0 ? void 0 : widgetData[`episode_${episodeId}`];
                    return (_jsx(StatusWidgetCard, { mode: mode, projectId: projectId, episodeInst: episodeInst, episodeData: episodeData, progressionStatus: progressionStatus, steps: steps, stepProjects: stepProjects, assetType: assetType }));
                })] }));
};
export default StatusWidget;
